import kanban from './kanban'
import note from './note'
import finder from './finder'

export default { kanban, note, finder }
